/**
 * @file 组件入口
 * @author qiaogang
 * @date 2020-02-10
 */

import Toast from './Toast.vue';

let timer;
const DURATION = 3000;

export default {
  install: function(_vue) {
    const ToastConstructor = _vue.extend(Toast);
    let instance;

    const createElement = () => {
      return new ToastConstructor({
        el: document.createElement('div'),
      });
    };

    _vue.prototype.$coolToast = (options) => {
      if (!instance) {
        instance = createElement();
        // 添加到页面
        document.body.appendChild(instance.$el);
      }

      if (typeof options === 'string') {
        options = {
          text: options,
          time: DURATION
        };
      }
      for (const key in options) {
        if (options.hasOwnProperty(key)) {
          const value = options[key];
          instance[key] = value;
        }
      }

      instance.show = true;

      if (options.time == null) {
        options.time = DURATION;
      }

      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        instance.show = false;
        // FIXME: 多个 Toast 时，后一个覆盖前一个的时候，需要处理 finished 的逻辑
        typeof options !== 'string' && typeof options.finished === 'function' && options.finished();
        timer = null;
      }, options.time);
    };
  }
};
